<template>
  <div class="container mt-5">
    <h2 class="text-center">Set Password</h2>
    <form @submit.prevent="$emit('confirm-signup')" class="mt-4">
      <div class="mb-3">
        <label for="password" class="form-label">Password</label>
        <input 
          type="password" 
          class="form-control" 
          id="password" 
          v-model="form.password" 
          @input="checkPasswordsMatch" 
          required
        />
      </div>
      <div class="mb-3">
        <label for="verifyPassword" class="form-label">Verify Password</label>
        <input 
          type="password" 
          class="form-control" 
          id="verifyPassword" 
          v-model="form.verifyPassword" 
          @input="checkPasswordsMatch" 
          required
        />
      </div>
      <div v-if="!passwordsMatch" class="text-danger mb-3">
        Passwords do not match
      </div>
      <button 
        type="button" 
        class="btn btn-primary w-100" 
        @click="$emit('show-confirm-signup')"

        :disabled="!passwordsMatch || !form.password || !form.verifyPassword">
      
        Next
        
      </button>
      <button 
        type="button" 
        class="btn btn-link w-100 mt-2" 
        @click="$emit('showConfirmSignup')">
        Back to Sign Up
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'PasswordEntry',
  props: ['form', 'passwordsMatch'],
  methods: {
    checkPasswordsMatch() {
      this.$emit('check-passwords-match');
    }
  }
};
</script>

<style>
/* Add any component-specific styles here */
</style>
